import React, { useState, useEffect } from "react";
import "./Superadminclaim.css";
import TablePagination from "@mui/material/TablePagination";
import {
  fetchclaimCommunity,
  updateClaim,
} from "../../../Services/Community/ClaimCommunity/claimCommunityApi";
import { useDispatch, useSelector } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";

function Superadminclaimcomp() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const fetchClaim = useSelector((state) => state.fetchclaimCommunity.data);
  const [allClaim, setAllClaim] = useState();
  const [selectedClaim, setSelectedClaim] = useState("");
  const [loading, setLoading] = useState(true);
  const [isDeclineModalOpen, setIsDeclineModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    community_id: "",
    status: "",
  });

  useEffect(() => {
    dispatch(fetchclaimCommunity())
      .unwrap()
      .then((res) => {
        if (res?.data) {
          setAllClaim(res.data);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error fetching claims:", err);
      });
  }, [dispatch]);

  useEffect(() => {
    if (fetchClaim) {
      setAllClaim(fetchClaim.data);
    }
  }, [fetchClaim]);

  const pendingClaims = allClaim?.filter((data) => data.status == null);

  // console.log(allClaim.length, "allClaim-------------------->");

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleSubmit = (status) => {
    // if (validateForm()) {
    const formDataToSubmit = new FormData();
    formDataToSubmit.append("community_id", selectedClaim);
    formDataToSubmit.append("status", status);
    dispatch(updateClaim(formDataToSubmit))
      .unwrap()
      .then((res) => {
        toast.success(res.message);
        dispatch(fetchclaimCommunity());
      })
      .catch((err) => {
        toast.error(err.errors);
      });
    // }
  };

  if (loading)
    return (
      <div>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <CircularProgress size={50} sx={{ color: "#e55426" }} />
        </Box>
      </div>
    );

  return (
    <>
      <div className="back-btn">
        <button onClick={() => navigate(-1)} className="back-btn-button">
          {/* <img src={chevronleft} alt="chevron-left" className="left-icon" />
           */}
          <ArrowBackIcon className="left-icon" />
          Back
        </button>
      </div>
      <div className="community-section">
        <div className="community-inner-wrap">
          <div className="add-new-community d-flex justify-content-between align-items-center">
            <div className="community-heading">Claim Notifications</div>
          </div>
        </div>
        <div className="all-commmunities-table">
          <div className="inner-wrap-all">
            {/* <div className="title-search-block d-flex justify-content-between align-items-center">
              <div className="allcommunities">All Communities</div>
              <div className="searchbar">
                <input
                  type="search"
                  placeholder="Search..."
                  className="inputsearch"
                />
              </div>
            </div> */}
            <div className="community-name-table communityblk">
              <div className="table-inner pt-0">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Community Name</th>
                      <th scope="col">Claim by</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pendingClaims?.map((claim) => (
                      <tr>
                        <td>{claim?.community?.community_name}</td>
                        <td>
                          {claim?.user.first_name} {claim?.user.last_name}
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn-submit-claim"
                            onClick={() => {
                              setSelectedClaim(claim?.id);
                              handleSubmit("accept");
                            }}
                          >
                            Accept
                          </button>
                          <button
                            type="button"
                            class="btn-submit-claim"
                            onClick={() => {
                              setSelectedClaim(claim?.id);
                              handleSubmit("decline");
                            }}
                          >
                            Decline
                          </button>
                        </td>
                        {/* <td>
                          <button
                            className="orange-filled-btn claimbtn"
                            data-bs-toggle="modal"
                            data-bs-target="#view"
                          >
                            View
                          </button>
                          <div
                            class="modal fade"
                            id="view"
                            tabindex="-1"
                            aria-labelledby="exampleModalLabel"
                            aria-hidden="true"
                          >
                            <div class="modal-dialog modal-dialog-centered">
                              <div class="modal-content">
                                <div class="modal-header">
                                  <h1
                                    class="modal-title fs-5"
                                    id="exampleModalLabel"
                                  >
                                    Submitted Documents
                                  </h1>
                                  <button
                                    type="button"
                                    class="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                  ></button>
                                </div>
                                <div class="modal-body">
                                  <div className="upload-file-claim-block view-table d-flex  justify-content-between gap-3">
                                    <div className="choose-file-box d-flex align-items-center">
                                      <a
                                        className="d-block doc-view-bloc"
                                        href="#"
                                      >
                                        View Document 1{" "}
                                      </a>
                                    </div>

                                    <div className="choose-file-box d-flex align-items-center">
                                      <a
                                        className="d-block doc-view-bloc"
                                        href="#"
                                      >
                                        View Document 2{" "}
                                      </a>
                                    </div>
                                    <div className="choose-file-box d-flex align-items-center">
                                      <a
                                        className="d-block doc-view-bloc"
                                        href="#"
                                      >
                                        {" "}
                                        View Document 3{" "}
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <div class="modal-footer d-flex gap-2">
                                  <button
                                    type="button"
                                    class="btn-decline"
                                    data-bs-dismiss="modal"
                                  >
                                    Decline
                                  </button>
                                  <button
                                    type="button"
                                    class="btn-submit-claim"
                                  >
                                    Accept
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <TablePagination
                component="div"
                count={100}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                className="table-paginator-communities"
              />
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default Superadminclaimcomp;
